// client/src/components/donations/ManageGiftPage.jsx
//
// /give/manage/:token — the link in every monthly-gift receipt (Roadmap
// Phase 5.1). Shows the monthly gift and lets the donor stop it. No sign-in;
// the token is signed by the server.

import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getManagedGift, cancelManagedGift, formatMoney, errorText } from '../../services/donationsApi';
import './Donations.css';

export default function ManageGiftPage() {
  const { token } = useParams();
  const { t } = useTranslation();
  const [gift, setGift] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    getManagedGift(token)
      .then((r) => setGift(r.gift))
      .catch((err) => setError(errorText(err, t('donations.manage.invalid', 'This link isn’t valid.'))));
  }, [token, t]);

  const cancel = async () => {
    if (!window.confirm(t('donations.manage.confirm', 'Stop your monthly gift to {{org}}? No further payments will be taken.', { org: gift.organization }))) return;
    setBusy(true); setError('');
    try {
      await cancelManagedGift(token);
      setGift((g) => ({ ...g, status: 'canceled' }));
    } catch (err) {
      setError(errorText(err, t('donations.manage.cancelError', 'Your monthly gift couldn’t be stopped. Try again, or contact the organization.')));
    } finally { setBusy(false); }
  };

  return (
    <main className="dn-public">
      <div className="dn-shell">
        <section className="dn-card">
          <h1 className="dn-title">{t('donations.manage.title', 'Your monthly gift')}</h1>
          {!gift && !error && <p>{t('common.loading', 'Loading…')}</p>}
          {error && <p className="dn-error" role="alert">{error}</p>}
          {gift && (
            <div className="dn-form">
              <p className="dn-desc">
                {t('donations.manage.summary', '{{amount}} a month to {{org}} ({{page}}).', {
                  amount: formatMoney(Number(gift.amountCents) + Number(gift.feeCoverCents || 0), gift.currency),
                  org: gift.organization, page: gift.page || '',
                })}
              </p>
              {gift.status === 'canceled' ? (
                <p className="dn-ok" role="status">{t('donations.manage.canceled', 'This monthly gift is stopped. No further payments will be taken.')}</p>
              ) : (
                <>
                  {gift.status === 'past_due' && <p className="dn-error">{t('donations.manage.pastDue', 'The last payment didn’t go through.')}</p>}
                  <button type="button" className="dn-secondary" onClick={cancel} disabled={busy}>
                    {t('donations.manage.stop', 'Stop my monthly gift')}
                  </button>
                </>
              )}
            </div>
          )}
        </section>
      </div>
    </main>
  );
}
